<fieldset class="form-domain-step-features" ngModelGroup="features">
    <form-field-select
        *ngIf="customer.plan_traits.accessibility"
        [(ngModel)]="featureAccessibilityGuidelineId"
        name="featureAccessibilityGuidelineId"
        (ngModelChange)="onGuidelineChange()"
        [options]="accessibilities"
        [label]="'Accessibility' | translate"
        returnValue="accessibility_guideline_id"
        [removeButton]="true"
        [defaultOption]="'None' | translate">
    </form-field-select>

    <div class="row mt-3" *ngIf="isWcag">
        <div class="col-sm-8 text-right">
            <label for="customer_plan_traits_accessibility_errors_only" class="col-form-label text-bold">
                {{'Exclude checks that require manual review' | translate}}
                <span class="outer-l-smurf fas fa-question-circle" aria-hidden="true"
                      [ngbTooltip]="'If this option is turned on, the domain scan only includes accessibility checks that can be automatically identified as errors. Checks requiring manual review are excluded.' | translate"
                      placement="top-right" container="body" [triggers]="'focus hover'">
                </span>
            </label>
        </div>
        <div class="col-sm-40 pl-4">
            <mon-switch
                name="customer_plan_traits_accessibility_errors_only"
                [(ngModel)]="domain.features.accessibility_errors_only">
            </mon-switch>
        </div>
    </div>

    <div class="form-group row mb-2" *ngIf="(customer.plan_traits.accessibility && domain.features.accessibility) || customer.plan_traits.source_code_excludes">
        <label class="col-form-label col-sm-8 text-bold text-right"
               for="source_code_excludes"
               translate>
            Source Code Excludes
        </label>
        <div class="col-sm-40">
            <angular-selector
                id="source_code_excludes"
                name="sourceCodeExcludes"
                (change)="onSCEChange($event.oldValue, $event.newValue)"
                [(ngModel)]="domainExcludes"
                labelAttr="label"
                [debounce]="300"
                [remote]="getSourceCodeExcludes()"
                [removeButton]="true"
                [closeAfterSelection]="true"
                [dropdownItemTemplate]="'app/forms/domain/steps/features/dropdown-templates/sce-dropdown-item.html'"
                [viewItemTemplate]="'app/forms/domain/steps/features/dropdown-templates/sce-select.html'"
                [multiple]="true">
            </angular-selector>
        </div>
    </div>

    <form-field-select
        *ngIf="customer.plan_traits.readability"
        [(ngModel)]="domain.features.readability_test"
        name="featuresReadabilityTest"
        [options]="readabilities"
        [label]="'Readability' | translate"
        returnValue="readability_test_id"
        [removeButton]="true"
        [defaultOption]="'None' | translate">
    </form-field-select>

    <div class="row" *ngIf="customer.plan_traits.readability && domain.features.readability_test">
        <div class="col-sm-8 text-right">
            <label class="col-form-label text-bold" for="readability_test_min_words">
                <span translate>Minimum words</span>
                <span class="outer-l-smurf fas fa-question-circle" aria-hidden="true"
                      [ngbTooltip]="'Choose minimum word count for a page to be included in the readability test' | translate"
                      placement="top-right" container="body" [triggers]="'focus hover'">
                </span>
                <span>*</span>
            </label>
        </div>
        <div class="col-sm-40">
            <form-field-input
                    #readabilityTestMinWords="ngModel"
                [(ngModel)]="domain.features.readability_test_min_words"
                [placeholder]="'Choose the minimum amount of words to scan for readability on a page' | translate"
                [required]="true"
                name="features_readability_miminum_words_count"
                type="number">
            </form-field-input>
            <form-field-errors [input]="readabilityTestMinWords.control"></form-field-errors>
        </div>
    </div>

    <div class="row mt-3" *ngIf="customer.plan_traits.statistics">
        <div class="col-sm-8 text-right">
            <label for="customer_plan_traits_statistics" class="col-form-label text-bold">
                {{'Site Analytics' | translate}}
            </label>
        </div>
        <div class="col-sm-40 pl-4">
            <mon-switch
                name="customer_plan_traits_statistics"
                [(ngModel)]="domain.features.statistics">
            </mon-switch>
        </div>
    </div>

    <div class="row mt-3" *ngIf="showAutofix">
        <div class="col-sm-8 text-right">
            <label for="domain_features_autofix" class="col-form-label text-bold" translate>PageCorrect</label>
        </div>
        <div class="col-sm-40 d-flex align-items-start pl-4">
            <mon-switch
                name="domain_features_autofix"
                [(ngModel)]="domain.features.page_fix">
            </mon-switch>
            <div class="ml-2 mt-1">
                <button [attr.aria-disabled]="!domain.features.page_fix"
                        type="button"
                        [ngClass]="{'mon-disabled': !domain.features.page_fix}"
                        (click)="domain.features.page_fix && openPageCorrectSettings()"
                        class="btn-link-style btn-no-style">
                    {{ 'Open PageCorrect Settings' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="row mt-3" *ngIf="showDataPrivacy">
        <div class="col-sm-8 text-right">
            <label for="domain_features_data_privacy" class="col-form-label text-bold" translate>Data Privacy</label>
        </div>
        <div class="col-sm-40 d-flex align-items-start pl-4">
            <mon-switch
                name="domain_features_data_privacy"
                [(ngModel)]="domain.features.data_protection">
            </mon-switch>
            <div class="ml-2 mt-1">
                <button [attr.aria-disabled]="!domain.features.data_protection"
                        type="button"
                        [ngClass]="{'mon-disabled': !domain.features.data_protection}"
                        (click)="domain.features.data_protection && openDataPrivacy()"
                        class="btn-link-style btn-no-style">
                    {{ 'Open Data Privacy Settings' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-sm-8 text-right">
            <label for="scan_documents" class="col-form-label text-bold">
                {{'Scan documents' | translate}}
            </label>
        </div>
        <div class="col-sm-40 pl-4">
            <mon-switch
                [(ngModel)]="domain.scan.scan_documents"
                name="scan_documents">
            </mon-switch>
        </div>
    </div>

    <div class="row mt-3" *ngIf="'admin_page_assist' | domainActiveFeature:domain">
        <div class="col-sm-8 text-right">
            <label for="domain_features_page_assist" class="col-form-label text-bold" translate>Acquia Web Governance PageAssist</label>
        </div>
        <div class="col-sm-40 pl-4">
            <div class="d-flex align-items-start">
                <mon-switch class="pr-2"
                            name="domain_features_page_assist"
                            [(ngModel)]="domain.features.page_assist">
                </mon-switch>
            </div>
        </div>
    </div>

    <div class="row mt-3" *ngIf="customer.plan_traits.cookie_banner">
        <div class="col-sm-8 text-right">
            <label for="domain_features_cookie_banner" class="col-form-label text-bold" translate>Acquia Web Governance Consent Manager</label>
        </div>
        <div class="col-sm-40 pl-4">
            <div class="d-flex align-items-start">
                <mon-switch
                    class="pr-2"
                    name="domain_features_cookie_banner"
                    [(ngModel)]="domain.features.cookie_banner">
                </mon-switch>
            </div>
        </div>
    </div>
</fieldset>
